import { makeStyles } from '@material-ui/styles';
import Barcode from 'react-barcode';

import '../../assets/css/print-landscape.css';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        margin: 0,
        padding: 0,
        pageBreakAfter: 'auto'
    },
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        pageBreakInside: 'avoid',
    },
    name: {
        color: '#283851',
        paddingLeft: 20
    }
}));

const Cc2ToPrint = ({ data }) => {

    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div>
                {
                    data?.map(cc2 => {
                        return (
                            <div key={cc2.idcost_center_2} className={classes.container}>
                                <Barcode value={cc2.code} width={5} />
                                <h3 className={classes.name}>{cc2.name}</h3>
                            </div>
                        );
                    })
                }
            </div>
        </div >
    );
}

export default Cc2ToPrint;